import { useState } from "react";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import {
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
} from "@mui/material";

interface PasswordFieldProps {
  id: string;
  field?: any | null;
  label?: string | "";
  placeholder?: string | "";
}

const PasswordField = (props: PasswordFieldProps) => {
  const [isVisible, setIsVisible] = useState<boolean>(false);

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  const handleClickShowPassword = () => {
    setIsVisible(!isVisible);
  };

  return (
    <>
      {props?.label && (
        <InputLabel htmlFor={"filled-adornment-" + props.label}>
          {props.label}
        </InputLabel>
      )}
      <OutlinedInput
        {...props.field}
        id={props.id}
        label={props?.label}
        placeholder={props.placeholder}
        type={isVisible ? "text" : "password"}
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={handleClickShowPassword}
              onMouseDown={handleMouseDownPassword}
              edge="end"
            >
              {isVisible ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        }
      />
    </>
  );
};

export default PasswordField;
